import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { uploadIotAgentUrl } from "../../config";
import api from "../../api";
import { IInitialSliceState } from "../../common/types/commonTypes";

const UPLOAD_IOT_AGENT: string = "uploadIotAgent";

interface IUploadIotAgentResponse {
  message: string;
  status: string;
}

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
};
export const uploadIotAgent = createAsyncThunk(
  UPLOAD_IOT_AGENT,
  async (payload: { file: ArrayBuffer; name: string }, { rejectWithValue }) => {
    try {
      const headers: Record<string, string> = {
        "Content-Type": "application/octet-stream",
      };

      const uploadIotAgentResponse = await api.post<IUploadIotAgentResponse>(
        `${uploadIotAgentUrl}?filename=${payload.name}`,
        payload.file,
        { headers }
      );
      return uploadIotAgentResponse.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const uploadIotAgentSlice = createSlice({
  name: UPLOAD_IOT_AGENT,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadIotAgent.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = "";
      })
      .addCase(uploadIotAgent.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(uploadIotAgent.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

type Selector = {
  uploadIotAgentApi: ReturnType<typeof uploadIotAgentSlice.reducer>;
};

export const selector = (store: Selector) => store["uploadIotAgentApi"];

export default uploadIotAgentSlice.reducer;
